
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 20.99H.5a.5.5 0 01-.5-.5V4.52a1.5 1.5 0 011.5-1.5h7.2a1.51 1.51 0 011.08.46l2.29 2.38a.5.5 0 00.36.15H22.5a1.5 1.5 0 011.5 1.5V10a.5.5 0 01-1 0V7.51a.5.5 0 00-.5-.5H12.43a1.5 1.5 0 01-1.09-.46L9.06 4.17A.5.5 0 008.7 4H1.5a.5.5 0 00-.5.5V20h12a.5.5 0 010 1z"}}),_c('path',{attrs:{"d":"M18.5 20.99a.5.5 0 01-.5-.5v-10a.5.5 0 011 0v10a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M23.5 15.99h-10a.5.5 0 010-1h10a.5.5 0 010 1z"}})])
          )
        }
      }
    